import { ProductInterface } from 'types/types';
import { Link } from 'components/configurable-routing';
import Button from 'components/button';
import { css } from '@emotion/react';

const quantityLabel = (quantity: number) => {
  const lookup = [
    'one',
    'two',
    'three',
    'four',
    'five',
    'six',
    'seven',
    'eight',
    'nine',
    'ten',
    'many',
  ];

  if (quantity <= 1) return lookup[0];

  return quantity > lookup.length
    ? lookup[lookup.length - 1]
    : lookup[quantity - 1];
};

const AddToCartButton = ({
  product,
  callback,
  quantity = 1,
  loading,
}: {
  product: ProductInterface;
  callback: () => void;
  quantity?: number;
  loading?: boolean;
}) => (
  <>
    {product.externalListingLink ? (
      <Link href={product.externalListingLink} target="_blank">
        <Button
          size="large"
          padding="13px"
          fontSize={['small', 'large']}
          color="secondary"
          fontColor="white"
          disabled={loading || product.isSoldOut}
          css={css`
            width: 100%;
            outline: revert;
            outline-offset: 4px;
          `}
        >
          I want it!
        </Button>
      </Link>
    ) : (
      <Button
        size="large"
        padding="13px"
        fontSize={['small', 'large']}
        color="secondary"
        fontColor="white"
        onClick={callback}
        loading={loading}
        disabled={loading || product.isSoldOut}
        css={css`
          width: 100%;
          outline: revert;
          outline-offset: 4px;
        `}
      >
        I want {quantityLabel(quantity)}!
      </Button>
    )}
  </>
);

export default AddToCartButton;
